module.exports = __webpack_public_path__ + "downloads/Post_Basic_Sample.e6962a0c.xlsx";